import { memo } from 'react'

import { AppId } from '@inno-tools/container-bridge'
import { useAvailableApps } from 'modules/app-registry/hooks/useAvailableApps'
import { useNavigate } from 'react-router-dom'
import { useHistory, useUserContext } from 'shared/hooks'

import { FullPageAppTemplate } from '../../templates'
import styles from './CompanySearcher.module.scss'

export const CompanySearcherApp = memo(
  () => {
    const navigate = useNavigate()
    const { location } = window
    const history = useHistory()
    const { user } = useUserContext()
    const { apps } = useAvailableApps()

    return (
      <FullPageAppTemplate
        appId={AppId.COMPANY_SEARCHER}
        scope='companysearcher_v2'
        envKey={apps[AppId.COMPANY_SEARCHER].runtimeEnvKey}
        entryPath='./CompanySearcherApp'
        url={process.env.REACT_APP_COMPANY_SEARCHER_APP_DEV_PATH}
        cdnUrl={apps[AppId.COMPANY_SEARCHER].cdnUrl}
        appName={apps[AppId.COMPANY_SEARCHER].name}
        className={styles['company-searcher-wrapper']}
        appProps={{
          user,
          history: history,
          appPath: apps[AppId.COMPANY_SEARCHER].path,
          onNavigate: ({ pathname: nextPathname }: { pathname: string }) => {
            const { pathname } = location

            if (pathname !== nextPathname) {
              navigate(nextPathname)
            }
          }
        }}
      />
    )
  },
  // when there are no props, this is OK to use. without this comparison function, we will have higher memory usage
  () => true
)
